<template>
  <div>
    <div class="vx-card p-6">
      <div class="mt-5">
        <vs-tabs alignment="fixed">
          <vs-tab label="Command">
            <div class="flex flex-wrap items-center">
              <div class="flex-grow"></div>
              <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">{{ page * per_page - (per_page - 1) }} - {{ row_total - page * per_page > 0 ? page * per_page : row_total }} of {{ row_total }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="updatePerPage(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPage(25)">
                    <span>25</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPage(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPage(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="keyword" @keyup="search" placeholder="Search..." />
            </div>

            <div class="table-container">
              <table class="table">
                <thead>
                  <tr>
                    <th>No</th>
                    <th style="min-width: 120px">GPS Type</th>
                    <th>Command</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody v-if="loading">
                  <tr>
                    <td colspan="10" class="text-center">Loading....</td>
                  </tr>
                </tbody>
                <tbody v-else-if="data.length > 0">
                  <tr v-for='(item, index) in data' :key='index'>
                    <td>{{ ((page-1)*per_page) + (index+1) }}</td>
                    <td>{{ item.name }}</td>
                    <td>
                      <vs-chip v-for="(item, index) in parseCommand(item.commands, 'name')" :color="index%2 == 0 ? 'success' : 'primary'" :key="index">
                        {{ item }}
                      </vs-chip>
                    </td>
                    <td style="width: 90px">
                      <div class="flex">
                        <vx-tooltip text="Assign Command" position="top">
                          <vs-button :id="`editBtn${item.id}`" type="border" size="small" icon-pack="feather" icon="icon-edit" color="success" class="mr-2 vs-con-loading__container" @click="edit(item.id)"></vs-button>
                        </vx-tooltip>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="10" class="text-center">No Data Available</td>
                  </tr>
                </tbody>
              </table>

              <vs-pagination :total="n_page" v-model="page"></vs-pagination>
            </div>
          </vs-tab>

          <vs-tab label="Turn ON/OFF Machine">
           <OnOffMachine/>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>

    <vs-popup classContent="popup-example" :title="popupTitle" :active.sync="showPopup">
      <template>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-2/2 w-full">
            <vs-input disabled label="GPS Type" class="w-full" v-model="input.name" />
          </div>
        </div>
        <div>
          <h5 class="text-center mb-3">Command Master</h5>
          <hr>
          <div class="vx-row mb-5 mt-3">
            <div class="vx-col w-full" v-for="(item, index) in commandMaster" :key="index">
              <vs-checkbox :disabled="action === 'detail'" v-model="input.command" :vs-value="item.id">
                <table>
                  <tr>
                    <td>{{ item.name }}</td>
                  </tr>
                </table>
              </vs-checkbox>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full ml-auto">
            <vs-button id="submitBtn"  class="mr-3 mb-2 vs-con-loading__container" @click="submit">Submit</vs-button>
            <vs-button v-show="action === 'add'" color="warning" type="border" @click="reset" class="mb-2">Reset</vs-button>
          </div>
        </div>

      </template>
    </vs-popup>
  </div>

</template>

<script>
import vSelect from 'vue-select'
import OnOffMachine from '@/views/components/command-assignment/OnOffMachine.vue'

export default {
  components: {
    vSelect,
    OnOffMachine
  },

  data () {
    return {
      data: [],
      dataCommandOnOff: [],
      token: '',
      showPopup: false,
      popupTitle: '',
      action: '',

      loading: true,
      tempId: 0,


      input: {
          gps_type_id: '',
          command: []
      },
      commandMaster: [],

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error'
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total/this.per_page)
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if(this.page != 1) this.page = 1
      else this.initTable()
    },
  },

  created () {
    this.token = localStorage.getItem('userInfo') !== null ? JSON.parse(localStorage.getItem('userInfo')).token : ''
    this.initTable()

    this.getCommandMaster()
  },

  mounted () {
  },

  methods: {
    search() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800);
    },

    updatePerPage(n) {
      this.per_page = n
      this.initTable()
    },

    reset() {
      Object.keys(this.input).map(item => {
        this.input[item] = ''
      })
    },

    initTable() {
      this.loading = true
      this.$http.get(`${this.$api.endpoint}/command_assignment/datatable?page=${this.page}&per_page=${this.per_page}&search=${this.keyword}`, {
        headers: {
            Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.row_total = res.data.message.total
        this.data = res.data.message.data
        this.loading = false
      }).catch(error => {
        this.$gf.httpErrorHandler(error)
      })
    },


    edit(id) {
      this.tempId = id
      this.action = 'edit'
      this.popupTitle = 'Assign Command'

      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: "#editBtn" + id,
        scale: 0.45
      })

      this.$http.get(`${this.$api.endpoint}/command_assignment/detail/${id}`, {
        headers: {
            Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.$vs.loading.close(`#editBtn${id} > .con-vs-loading`)

        const data = res.data.message.data


        const command = data.commands
        const result = []
        command.map((item, index) => {
          result.push(item.command_id)
        })
        this.input.command = result

        this.input.name = data.name
        this.input.gps_type_id = this.tempId

        this.showPopup = true
      })
    },

    submit() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#submitBtn",
        scale: 0.45
      })

      let url = `${this.$api.endpoint}/command_assignment/update/${this.tempId}`

      this.$http.post(url, {
        commands: this.input.command
      },
      {
        headers:{
          Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.$vs.loading.close("#submitBtn > .con-vs-loading")

        this.notify = res.data.message.split('_').join(' ')

        this.showPopup = false
        this.initTable()
        this.reset()

        this.$vs.notify({
          title: 'Thank You',
          text: this.notify,
          color: 'success',
          position: 'top-right'
        })
      }).catch(error => {
        this.$vs.loading.close("#submitBtn > .con-vs-loading")
        this.$gf.httpErrorHandler(error)
      })
    },

    getCommandMaster() {
      this.$http.get(`${this.$api.endpoint}/command`, {
        headers: {
            Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        const data = res.data.message.data

        this.commandMaster = data
      })
    },

    parseCommand(command, key) {
      let result = []
      command.map(item => {
        if(item.command != null) result.push(item.command[key])
        // string += item.command.name
        // if(index+1 < command.length) string += ", "
      })

      return result
    }
  },
}

</script>
